import { HttpStatusCode, isAxiosError } from "axios";
import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { calculationFailureMessage, classifyCalculationFailure } from "src/api/client-api/post/calculationFailure";
import { getOnePostKey } from "src/api/client-api/post/useGetOnePost";
import { useSnackbar } from "src/utils/useSnackbar";
import { getAllActionPlanKey } from "./useGetAllActionPlan";
import { getOneActionPlanKey } from "./useGetOneActionPlan";
import { getAllActionPlanActionsKey } from "../ActionPlanAction/useGetAllActionPlanAction";
import { getOneActionPlanActionsKey } from "../ActionPlanAction/useGetOneActionPlanAction";

export type PrecisionAnswer = {
    actionPlanId: string;
    ssqPropertyId: number;
    value: string;
    isGenericValue: boolean;
};

export const useAnswerPrecisionQuestion = () => {
    const snackbar = useSnackbar();
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    return useMutation({
        mutationFn: ({ actionPlanId, ...answer }: PrecisionAnswer) =>
            loggedInApiCall.post(`/api/action_plans/${actionPlanId}/precision-answers`, answer),
        onSuccess: () => {
            queryClient.invalidateQueries([getOnePostKey]);
            queryClient.invalidateQueries([getOneActionPlanKey]);
            queryClient.invalidateQueries([getAllActionPlanKey]);
            queryClient.invalidateQueries([getOneActionPlanActionsKey]);
            queryClient.invalidateQueries([getAllActionPlanActionsKey]);
        },
        onError: (error: unknown) => {
            if (isAxiosError(error) && error.response?.status === HttpStatusCode.Conflict) {
                queryClient.invalidateQueries([getOneActionPlanKey]);
                return;
            }
            snackbar.forceClose();
            snackbar.setSnackbarProps({
                type: "error",
                message: calculationFailureMessage(classifyCalculationFailure(error), t),
                forceAutoHideInMilisecond: 10000,
            });
        },
    });
};
